var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671",
    transform: "translate(-12456 9399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "orderDetailsIconActive",
    transform: "translate(12456 -9399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12237",
    "data-name": "Path 12237",
    d: "M25,0A25,25,0,1,0,50,25,25.03,25.03,0,0,0,25,0Zm0,48.135A23.137,23.137,0,1,1,48.139,25,23.163,23.163,0,0,1,25,48.135Z",
    fill: "#A68367"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12238",
    "data-name": "Path 12238",
    d: "M25.452,36.495,24.7,40.752S25.489,36.281,25.452,36.495Z",
    fill: "#A68367",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_profile_1594246",
    transform: "translate(12469.386 -9388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12172",
    "data-name": "Path 12172",
    d: "M57.674,58.634a.74.74,0,0,1-.734.74H34.734a.741.741,0,0,1-.734-.74,11.837,11.837,0,1,1,23.674,0ZM45.837,45.317A6.658,6.658,0,1,1,52.5,38.658,6.658,6.658,0,0,1,45.837,45.317Z",
    transform: "translate(-34 -32)",
    fill: "#A68367",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerProfile);
export default __webpack_public_path__ + "static/media/customerProfile.034d1ff76c908a1d7a4ab54a659fcd61.svg";
export { ForwardRef as ReactComponent };